import { createSlice } from "@reduxjs/toolkit";
import { addOrUpdateReviewThunk, addProductThunk, deleteProductThunk, editProductThunk, fetchAllProductsThunk, fetchItemByIdThunk, fetchOrderByIdThunk, fetchOrdersThunk, fetchProductReviewsThunk, searchProductsByCategoriesThunk, searchProductsByNameThunk, updateOrderStatusThunk } from "../../thunks/thunks";
import { toast } from "react-toastify";

const productSlice = createSlice({
    name: 'products',
    initialState: {
      items: [],
      isLoading: false,
      error: null,
      item: null,
      filteredItems: [],
      orders:[],
      order: null,
      reviews:[],
      
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(addProductThunk.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(addProductThunk.fulfilled, (state, action) => {
          state.isLoading = false;
          state.items.push(action.payload); // Add the new product to the list
          
        })
        .addCase(addProductThunk.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(fetchAllProductsThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(fetchAllProductsThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.items = action.payload;
            state.filteredItems = action.payload;
          })
          .addCase(fetchAllProductsThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          })
          .addCase(deleteProductThunk.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(deleteProductThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.items = state.items.filter((item) => item.id !== action.payload);
          })
          .addCase(deleteProductThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          })
          
          // Edit product
          .addCase(editProductThunk.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(editProductThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.items = state.items.map((item) =>
              item.id === action.payload.id ? action.payload : item
            );
          })
          .addCase(editProductThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          })
          .addCase(fetchItemByIdThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(fetchItemByIdThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.item = action.payload;
          })
          .addCase(fetchItemByIdThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          })
          .addCase(searchProductsByNameThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(searchProductsByNameThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.filteredItems = action.payload;
          })
          .addCase(searchProductsByNameThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            
          })
          .addCase(searchProductsByCategoriesThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(searchProductsByCategoriesThunk.rejected, (state) => {
            state.isLoading = true;
            state.error = null;
            state.filteredItems = [];
            toast.error(
              "No products found with the selected categories",
              { autoClose: 3000, position: "top-center"}
            );
          }
          )
          .addCase(searchProductsByCategoriesThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            console.log("action.payload at fullfilled",action.payload);
            state.filteredItems = action.payload.data;
            console.log("filteredItems at thunk",state.filteredItems);
          })
          .addCase(fetchOrdersThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(fetchOrdersThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.orders = action.payload;
          })
          .addCase(fetchOrdersThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          })
          .addCase(fetchOrderByIdThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
            state.order = null;
          })
          .addCase(fetchOrderByIdThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.order = action.payload;
            console.log("orderid: ",action.payload);
          })
          .addCase(fetchOrderByIdThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          })
          .addCase(addOrUpdateReviewThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(addOrUpdateReviewThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            const updatedReview = action.payload.review;
          
            // Check if updatedReview exists and has _id property
            if (updatedReview && updatedReview._id) {
              // Replace or add the review in the reviews list
              const existingIndex = state.reviews.findIndex(
                (review) => review._id === updatedReview._id
              );
              if (existingIndex !== -1) {
                state.reviews[existingIndex] = updatedReview;
              } else {
                state.reviews.push(updatedReview);
              }
            } else {
              // Handle error if updatedReview is invalid
              console.error("Invalid review data:", updatedReview);
            }
          })
          .addCase(addOrUpdateReviewThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload.message || 'Something went wrong';
          })
          .addCase(fetchProductReviewsThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(fetchProductReviewsThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.reviews = action.payload.reviews;
            state.averageRating = action.payload.averageRating;
          })
          .addCase(fetchProductReviewsThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload || action.error.message;
          })
          .addCase(updateOrderStatusThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(updateOrderStatusThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            const updatedOrder = action.payload.order;
    
            // Update the specific order in the orders list
            state.orders = state.orders.map((order) =>
              order._id === updatedOrder._id ? updatedOrder : order
            );
          })
          .addCase(updateOrderStatusThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
          });
    },
  });
  
  export default productSlice.reducer;